import api from './api'

// Panel de gestión de niveles de acceso (/admin/users/*) -- app privada,
// solo alcanzable con login de developer (RoleRoute en routes.jsx).
// Reemplaza el /admin/chart-users/* legacy (retirado en la migración de
// niveles de acceso, docs/auth/diseno-niveles-acceso.md §6): ahora una
// misma fila `users` puede tener nivel 1 (has_chart_access) y/o nivel 2
// (has_agents_access), en vez del modelo chart_users de solo un status.
export const chartAdminService = {
  listRequests:  (level) => api.get('/admin/users/requests', { params: level ? { level } : {} }),
  listUsers:     () => api.get('/admin/users'),
  approve:       (requestId) => api.post(`/admin/users/requests/${requestId}/approve`),
  deny:          (requestId) => api.post(`/admin/users/requests/${requestId}/deny`),
  resendSetPassword: (userId) => api.post(`/admin/users/${userId}/resend-set-password`),
  grantAgents:   (userId) => api.post(`/admin/users/${userId}/grant-agents`),
  revokeAgents:  (userId) => api.post(`/admin/users/${userId}/revoke-agents`),
  grantRangoPremium:  (userId) => api.post(`/admin/users/${userId}/grant-rango-premium`),
  revokeRangoPremium: (userId) => api.post(`/admin/users/${userId}/revoke-rango-premium`),
  revokeChart:   (userId) => api.post(`/admin/users/${userId}/revoke-chart`),
  disable:       (userId) => api.post(`/admin/users/${userId}/disable`),
  enable:        (userId) => api.post(`/admin/users/${userId}/enable`),
  remove:        (userId) => api.delete(`/admin/users/${userId}`),
}
